var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',[_c('span',{staticClass:"font-weight-bold"},[_vm._t("name"),_vm._v(":  ")],2),_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }